export const uploadZapOrInstrModule = {
  state: () => ({
    zapOrInstr: "instr"
  }),
  mutations: {
    set_zap_or_instr(state, data) {
      state.zapOrInstr = state.zapOrInstr = data;
    }
  },
  actions: {},
  getters: {
    ZAPORINSTR: state => {
      return state.zapOrInstr;
    }
  }
};
